import {useSelector} from "react-redux";
import {useLocation} from "react-router";
import {css} from "@emotion/react";
import styled from "@emotion/styled";

import {Button} from "@pg-design/button-module";
import {onDesktop} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text";
import {parseSearch} from "@pg-mono/request";
import {rpAppLink} from "@pg-mono/rp-routes";

import {IRPStore} from "../../app/rp_reducer";
import {ArticleListLatestList} from "../../article/components/article_list/ArticleListLatestList";
import {CreditKnowledgeCheckList} from "./CreditKnowledgeCheckList";

const defaultKnowledgeCopy =
    "W Strefie wiedzy znajdziesz rzetelne artykuły i analizy dotyczące zakupu mieszkań oraz kredytów hipotecznych. Oferujemy praktyczne informacje, które pomogą Ci podejmować świadome decyzje na rynku nieruchomości.";

export const CreditKnowledgeBase = ({hideChecklist, copyVariant}: {hideChecklist?: boolean; copyVariant?: string}) => {
    const location = useLocation();
    const phrase = parseSearch(location.search)?.phrase;

    const list = useSelector((state: IRPStore) => state.credit.articles);

    return (
        <ArticleContainer>
            <Text variant="headline_2" as="p" css={articleText} strong={false}>
                Strefa wiedzy
            </Text>
            <Text variant="body_copy_0" css={articleText} strong={false}>
                {copyVariant ?? defaultKnowledgeCopy}
            </Text>

            {!hideChecklist && <CreditKnowledgeCheckList />}

            <ArticleListLatestList phrase={phrase} showHeader={false} articles={list} count={list.length} location={location} hidePagination />
            <Button href={rpAppLink.article.category({categorySlug: "finanse"})} css={buttonStyle} variant="filled_primary">
                zobacz więcej artykułów
            </Button>
        </ArticleContainer>
    );
};

const articleText = css`
    margin: 1.5rem 0 6rem 0;
    text-align: center;
`;

const buttonStyle = css`
    display: block;
    width: fit-content;
    margin: 0 auto;
`;

export const ArticleContainer = styled.div`
    ${onDesktop(css`
        max-width: 112.8rem;
        margin-right: auto;
        padding: 0;
    `)}
    margin-top: 12rem;

    padding-left: 2rem;
    padding-right: 2rem;
`;
import {useSelector} from "react-redux";
import {useLocation} from "react-router";
import {css} from "@emotion/react";
import styled from "@emotion/styled";

import {Button} from "@pg-design/button-module";
import {onDesktop} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text";
import {parseSearch} from "@pg-mono/request";
import {rpAppLink} from "@pg-mono/rp-routes";

import {IRPStore} from "../../app/rp_reducer";
import {ArticleListLatestList} from "../../article/components/article_list/ArticleListLatestList";
import {CreditKnowledgeCheckList} from "./CreditKnowledgeCheckList";

const defaultKnowledgeCopy =
    "W Strefie wiedzy znajdziesz rzetelne artykuły i analizy dotyczące zakupu mieszkań oraz kredytów hipotecznych. Oferujemy praktyczne informacje, które pomogą Ci podejmować świadome decyzje na rynku nieruchomości.";

export const CreditKnowledgeBase = ({hideChecklist, copyVariant}: {hideChecklist?: boolean; copyVariant?: string}) => {
    const location = useLocation();
    const phrase = parseSearch(location.search)?.phrase;

    const list = useSelector((state: IRPStore) => state.credit.articles);

    return (
        <ArticleContainer>
            <Text variant="headline_2" as="p" css={articleText} strong={false}>
                Strefa wiedzy
            </Text>
            <Text variant="body_copy_0" css={articleText} strong={false}>
                {copyVariant ?? defaultKnowledgeCopy}
            </Text>

            {!hideChecklist && <CreditKnowledgeCheckList />}

            <ArticleListLatestList phrase={phrase} showHeader={false} articles={list} count={list.length} location={location} hidePagination />
            <Button href={rpAppLink.article.category({categorySlug: "finanse"})} css={buttonStyle} variant="filled_primary">
                zobacz więcej artykułów
            </Button>
        </ArticleContainer>
    );
};

const articleText = css`
    margin: 1.5rem 0 6rem 0;
    text-align: center;
`;

const buttonStyle = css`
    display: block;
    width: fit-content;
    margin: 0 auto;
`;

export const ArticleContainer = styled.div`
    ${onDesktop(css`
        max-width: 112.8rem;
        margin-right: auto;
        padding: 0;
    `)}
    margin-top: 12rem;

    padding-left: 2rem;
    padding-right: 2rem;
`;
